"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useMutation } from "@tanstack/react-query";
import { commonApiDeleteWithBody, commonApiPost } from "@/services/api/common-api";
import { ApiWaveSubscriptionActions } from "@/generated/models/ApiWaveSubscriptionActions";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { WAVE_DEFAULT_SUBSCRIPTION_ACTIONS } from "@/components/react-query-wrapper/utils/query-utils";
enum WaveItemFollowState {
  FOLLOWING = "FOLLOWING",
  FOLLOW = "FOLLOW",
  CANT_FOLLOW = "CANT_FOLLOW",
}
export default function WaveItemFollow(t0) {
  const $ = _c(70);
  const {
    wave
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy,
    setToast,
    requestAuth
  } = useContext(AuthContext);
  const {
    onWaveFollowChange
  } = useContext(ReactQueryWrapperContext);
  const isSubscribed = !!wave.subscribed_actions.length;
  const label = isSubscribed ? "Following" : "Follow";
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile?.handle) {
    t1 = () => !!connectedProfile?.handle && !activeProfileProxy;
    $[0] = activeProfileProxy;
    $[1] = connectedProfile?.handle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getCanSubscribe = t1;
  const [canSubscribe, setCanSubscribe] = useState(getCanSubscribe());
  let t2;
  if ($[3] !== getCanSubscribe) {
    t2 = () => setCanSubscribe(getCanSubscribe());
    $[3] = getCanSubscribe;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activeProfileProxy || $[6] !== connectedProfile) {
    t3 = [connectedProfile, activeProfileProxy];
    $[5] = activeProfileProxy;
    $[6] = connectedProfile;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  const [mutating, setMutating] = useState(false);
  let t4;
  if ($[8] !== canSubscribe || $[9] !== mutating) {
    t4 = () => mutating || !canSubscribe;
    $[8] = canSubscribe;
    $[9] = mutating;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const getIsDisabled = t4;
  let t5;
  if ($[11] !== getIsDisabled) {
    t5 = getIsDisabled();
    $[11] = getIsDisabled;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const [isDisabled, setIsDisabled] = useState(t5);
  let t6;
  if ($[13] !== getIsDisabled) {
    t6 = () => setIsDisabled(getIsDisabled());
    $[13] = getIsDisabled;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== canSubscribe || $[16] !== mutating) {
    t7 = [mutating, canSubscribe];
    $[15] = canSubscribe;
    $[16] = mutating;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  useEffect(t6, t7);
  let t8;
  if ($[18] !== canSubscribe || $[19] !== isSubscribed) {
    t8 = () => {
      if (!canSubscribe) {
        return WaveItemFollowState.CANT_FOLLOW;
      }
      if (isSubscribed) {
        return WaveItemFollowState.FOLLOWING;
      }
      return WaveItemFollowState.FOLLOW;
    };
    $[18] = canSubscribe;
    $[19] = isSubscribed;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const getState = t8;
  let t9;
  if ($[21] !== getState) {
    t9 = getState();
    $[21] = getState;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const [state, setState] = useState(t9);
  let t10;
  if ($[23] !== getState) {
    t10 = () => setState(getState());
    $[23] = getState;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== canSubscribe || $[26] !== isSubscribed) {
    t11 = [isSubscribed, canSubscribe];
    $[25] = canSubscribe;
    $[26] = isSubscribed;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  useEffect(t10, t11);
  let t12;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      [WaveItemFollowState.FOLLOWING]: "tw-bg-iron-800 tw-text-iron-300 hover:tw-bg-iron-700 hover:tw-border-iron-700 focus-visible:tw-outline-iron-700 tw-border-iron-800",
      [WaveItemFollowState.FOLLOW]: "tw-text-white hover:tw-bg-primary-600 hover:tw-border-primary-600 focus-visible:tw-outline-primary-600 tw-bg-primary-500 tw-border-primary-500",
      [WaveItemFollowState.CANT_FOLLOW]: "tw-opacity-50 tw-cursor-not-allowed tw-bg-primary-500 tw-ring-primary-500 tw-text-white"
    };
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const CLASSES = t12;
  let t13;
  if ($[29] !== wave.id) {
    t13 = async () => {
      await commonApiPost({
        endpoint: `waves/${wave.id}/subscriptions`,
        body: {
          actions: WAVE_DEFAULT_SUBSCRIPTION_ACTIONS
        }
      });
    };
    $[29] = wave.id;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== onWaveFollowChange || $[32] !== wave.id) {
    t14 = () => {
      onWaveFollowChange({
        waveId: wave.id,
        following: true
      });
    };
    $[31] = onWaveFollowChange;
    $[32] = wave.id;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== setToast) {
    t15 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[34] = setToast;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => {
      setMutating(false);
    };
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t13 || $[38] !== t14 || $[39] !== t15) {
    t17 = {
      mutationFn: t13,
      onSuccess: t14,
      onError: t15,
      onSettled: t16
    };
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  const subscribeMutation = useMutation(t17);
  let t18;
  if ($[41] !== wave.id) {
    t18 = async () => {
      await commonApiDeleteWithBody({
        endpoint: `waves/${wave.id}/subscriptions`,
        body: {
          actions: WAVE_DEFAULT_SUBSCRIPTION_ACTIONS
        }
      });
    };
    $[41] = wave.id;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== onWaveFollowChange || $[44] !== wave.id) {
    t19 = () => {
      onWaveFollowChange({
        waveId: wave.id,
        following: false
      });
    };
    $[43] = onWaveFollowChange;
    $[44] = wave.id;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== setToast) {
    t20 = error_0 => {
      setToast({
        message: error_0 as unknown as string,
        type: "error"
      });
    };
    $[46] = setToast;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = () => {
      setMutating(false);
    };
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t18 || $[50] !== t19 || $[51] !== t20) {
    t22 = {
      mutationFn: t18,
      onSuccess: t19,
      onError: t20,
      onSettled: t21
    };
    $[49] = t18;
    $[50] = t19;
    $[51] = t20;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  const unSubscribeMutation = useMutation(t22);
  let t23;
  if ($[53] !== isSubscribed || $[54] !== requestAuth || $[55] !== subscribeMutation || $[56] !== unSubscribeMutation) {
    t23 = async e => {
      e.preventDefault();
      setMutating(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setMutating(false);
        return;
      }
      if (isSubscribed) {
        await unSubscribeMutation.mutateAsync();
        return;
      }
      await subscribeMutation.mutateAsync();
    };
    $[53] = isSubscribed;
    $[54] = requestAuth;
    $[55] = subscribeMutation;
    $[56] = unSubscribeMutation;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  const onSubscribe = t23;
  const t24 = `tw-p-[1px] tw-w-full sm:tw-w-auto tw-flex tw-rounded-lg tw-bg-gradient-to-b ${state === WaveItemFollowState.FOLLOW ? " tw-from-primary-400 tw-to-primary-500" : "tw-from-iron-700 tw-to-iron-700"}`;
  const t25 = `${CLASSES[state]} tw-flex tw-w-full sm:tw-w-auto tw-gap-x-1.5 tw-items-center tw-justify-center tw-border tw-border-solid tw-rounded-lg tw-px-2.5 tw-py-1.5 tw-text-sm tw-font-semibold tw-shadow-sm focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 tw-transition tw-duration-300 tw-ease-out`;
  let t26;
  if ($[58] !== isSubscribed || $[59] !== mutating) {
    t26 = mutating ? <CircleLoader /> : isSubscribed ? <svg className="tw-h-3 tw-w-3" viewBox="0 0 17 15" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="17" height="15"><path d="M14.7953 0.853403L5.24867 10.0667L2.71534 7.36007C2.24867 6.92007 1.51534 6.8934 0.982005 7.26674C0.462005 7.6534 0.315338 8.3334 0.635338 8.88007L3.63534 13.7601C3.92867 14.2134 4.43534 14.4934 5.00867 14.4934C5.55534 14.4934 6.07534 14.2134 6.36867 13.7601C6.84867 13.1334 16.0087 2.2134 16.0087 2.2134C17.2087 0.986737 15.7553 -0.093263 14.7953 0.84007V0.853403Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" /></svg> : <svg className="tw-h-5 tw-w-5 -tw-ml-1" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[58] = isSubscribed;
    $[59] = mutating;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  const t27 = !mutating && label;
  let t28;
  if ($[61] !== isDisabled || $[62] !== onSubscribe || $[63] !== t25 || $[64] !== t26 || $[65] !== t27) {
    t28 = <button onClick={onSubscribe} type="button" disabled={isDisabled} className={t25}>{t26}{t27}</button>;
    $[61] = isDisabled;
    $[62] = onSubscribe;
    $[63] = t25;
    $[64] = t26;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== t24 || $[68] !== t28) {
    t29 = <div className={t24}>{t28}</div>;
    $[67] = t24;
    $[68] = t28;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  return t29;
}